<template>
  <div class="scene-box">
    <div class="engine-box">
      <div
        class="catalog-tree-btn-box"
        v-if="isVectorView() && mainSceLoaded"
        @click="openVectorAttrPanel">
        <icon-svg
          size="26"
          class="icon"
          icon-class="ic-shuxing1" />
      </div>
      <div
        class="catalog-tree-btn-box"
        v-if="canvasViewMode !== 'cad' && isCadToolBarVisible()"
        @click="openViewTreePanel">
        <icon-svg
          size="20"
          class="icon"
          icon-class="ic-mulushu1" />
      </div>
      <div
        :class="`cad-toolbar-box 
        ${canvasViewMode === 'bimCad' ? 'left50' : 'left0'}
        ${
          canvasViewMode !== 'cad' && canvasViewMode !== 'bimCad'
            ? 'margin30'
            : ''
        }`"
        v-if="isCadToolBarVisible()">
        <div class="svg-box">
          <icon-svg
            size="32"
            title="图层"
            icon-class="ic-tuceng2"
            class="icon"
            @click.native="openCadLayerPanel" />
        </div>
        <div class="svg-box">
          <icon-svg
            size="32"
            title="布局"
            icon-class="ic-buju2"
            class="icon"
            @click.native="openCadLayoutPanel" />
        </div>
        <div
          class="svg-box"
          v-if="canvasViewMode !== 'cad'">
          <icon-svg
            size="32"
            title="切换视图"
            icon-class="ic-qiehuanshitu11-011"
            class="icon"
            @click.native="toggleCanvasViewMode" />
        </div>
      </div>
      <DataSetViewEngine
        ref="engineDemo"
        :onUIThemeChange="onUIThemeChange"
        :modelClick="handleModelClick"
        :loadMainScene="loadMainScene"
        :onMainSceLoaded="onMainSceLoaded"
        :onCadLoadFinish="onCadLoadFinish"
        :togglePanelVisible="togglePanelVisible"
        :handleElemClick="handleElemClick"
        :handleCadElemClick="handleCadElemClick"
        :vectorClick="handleVectorClick" />
      <ViewAngle
        v-if="isViewAngleVisible()"
        :definedType="1" />
    </div>
    <viewTreePanel
      ref="viewTree"
      v-show="viewTreePanelVisible"
      :toggleViewAngleBtn="toggleViewAngleBtn"
      :resetViewAngle="resetViewAngle"
      :limitDragArea="viewTreePanelLimit"
      :closePanel="closeViewTreePanel"
      :updateAttributeType="updateAttributeType"
      :updateAttributeData="updateAttributeData"
      :loadBIMCAD="loadBIMCAD"
      :resetElemAttr="resetElemAttr"
      :showRoom="showRoom"
      :setCanvasViewMode="setCanvasViewMode"
      :closeCadLayerPanel="closeCadLayerPanel"
      :closeCadLayoutPanel="closeCadLayoutPanel" />
    <attributePanel
      v-show="attributePanelVisible"
      :isRvtGroupMode="isRvtGroupMode"
      :isElemExist="isElemExist"
      :attributeData="attributeData"
      :closePanel="closeAttributePanel" />
    <texturePanel
      ref="texture"
      v-if="texturePanelVisible"
      :modelInfo="modelInfo"
      :openConfigDialog="openEffectDialog"
      :openCountDown="openCountDown"
      :reloadMainScene="reloadMainScene"
      :closePanel="closeTexturePanel" />
    <textureEffectDialog
      :visible="effectDialog"
      :textureInfo="textureInfo"
      :submitEffectInfo="submitEffectInfo"
      :closeDialog="cloaseEffectDialog" />
    <countDown v-if="countDownVisible" />
    <RenderLevelDialog
      ref="coplaneDialg"
      v-if="renderLevelVisible"
      :theme="theme"
      :closeDialog="closeRenderLevelDialog" />
    <div
      class="mouse-tip-box"
      v-show="mouseTipVisible"
      ref="mouseTip">
      <div>左键：选择构件/取消选择</div>
      <div>右键：绘制结束</div>
    </div>
    <PathProgress
      v-if="pathProgressVisible"
      :percentage="pathProgress" />
    <CadLayerPanel
      ref="cadLayer"
      v-if="cadlayerPanelVisible && cadLoadFinish"
      :limitDragArea="cadLayerPanelLimit"
      :closePanel="closeCadLayerPanel" />
    <CadLayoutPanel
      ref="cadLayout"
      v-if="cadLayoutPanelVisible && cadLoadFinish"
      :cadInfo="rvtCadInfo"
      :limitDragArea="cadLayerPanelLimit"
      :closePanel="closeCadLayoutPanel" />
    <VectorAttrPanel
      v-if="isVectorAttrPanelVisible"
      :vectorAttrData="vectorAttrData"
      :closePanel="closeVectorAttrPanel" />
  </div>
</template>

<script>
import attributePanel from '@/components/AttributePanel.vue'
import ViewAngle from '@/components/ViewAngle.vue'
import viewTreePanel from './components/ViewTreePanel.vue'
import texturePanel from './components/TexturePanel.vue'
import countDown from './components/CountDown.vue'
import textureEffectDialog from './components/TextureEffectDialog.vue'
import DataSetViewEngine from './components/DataSetViewEngine.vue'
import PathProgress from './components/PathProgress.vue'
import RenderLevelDialog from './components/RenderLevelDialog.vue'
import CadLayerPanel from './components/CadLayerPanel.vue'
import VectorAttrPanel from './components/VectorAttrPanel.vue'
import CadLayoutPanel from './components/CadLayoutPanel.vue'

import { highLightElems } from '@/utils/engineUtils'

import {
  getProjectTree,
  getCadDatasetFiles,
  getDataSetResService,
  getProjectParam,
  getViewAngleService,
  getTextureList,
  getCadIdByElemId,
  getElemIdByCadId,
  getVectorAttrService,
  getRvtGroupByElemIdService,
  getRvtGroupAttrService,
  getBimElemIdsByGroupService
} from '@/service/interface'

import { Store } from '@/utils/store'

export default {
  data() {
    return {
      modelInfo: [],
      mainSceLoaded: false,
      viewAngleVisible: true,

      cadlayerPanelVisible: false,
      viewTreePanelVisible: false,

      isRvtGroupMode: false,
      elementId: '',
      attributePanelVisible: false,
      attributeType: 'element',
      attributeData: [],

      texturePanelVisible: false,
      effectDialog: false,
      textureInfo: null,

      mouseTipVisible: false,
      countDownVisible: false,

      pathProgressVisible: false,
      pathProgress: 0,

      theme: 'light',
      renderLevelVisible: false,

      // canvas显示模式
      // model: 单个数据集
      // bimCad: BIM-CAD分屏展示
      // rvtCad: 带二维图纸的rvt模型单独展示二维图纸
      // cad: 二维图纸正常展示
      canvasViewMode: 'model',
      rvtCadInfo: {},

      cadLoadFinish: false,
      viewTreePanelLimit: '',
      cadLayerPanelLimit: 'right',

      cadLayoutPanelVisible: false,

      isVectorAttrPanelVisible: false,
      vectorAttrData: []
    }
  },
  props: {
    setTitle: Function
  },
  computed: {
    isElemExist() {
      return this.elementId ? true : false
    }
  },
  components: {
    viewTreePanel,
    texturePanel,
    textureEffectDialog,
    attributePanel,
    DataSetViewEngine,
    ViewAngle,
    countDown,
    PathProgress,
    RenderLevelDialog,
    CadLayerPanel,
    CadLayoutPanel,
    VectorAttrPanel
  },
  created() {
    this.initHeader()
  },
  mounted() {
    this.$eventManage.on('mouseMove', this.onMouseMove)
    this.$eventManage.on('pathProgress', this.onPathProgress)
  },
  beforeDestroy() {
    this.$eventManage.off('mouseMove', this.onMouseMove)
    this.$eventManage.off('pathProgress', this.onPathProgress)
    sessionStorage.removeItem('isAuthorized')
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.coplaneDialg) {
      this.$refs.coplaneDialg.handleCloseDialog().then(response => {
        if (response) {
          this.handleTextureEdit().then(flag => {
            if (flag) {
              this.$refs.engineDemo.resetViewMode()
              this.$refs.engineDemo.clearCamForcedLoc()

              this.deleteCustomBtn('Coplane')
              this.deleteCustomBtn('Attribute')
              this.deleteCustomBtn('Catalog_Tree')
              this.deleteCustomBtn('Texture')
              window.BlackHole3D.Clip.endClip()
              this.copyCanvas()
              next()
            }
          })
        }
      })
    } else {
      this.handleTextureEdit().then(flag => {
        if (flag) {
          this.$refs.engineDemo.resetViewMode()
          this.$refs.engineDemo.clearCamForcedLoc()

          this.deleteCustomBtn('Coplane')
          this.deleteCustomBtn('Attribute')
          this.deleteCustomBtn('Catalog_Tree')
          this.deleteCustomBtn('Texture')
          window.BlackHole3D.Clip.endClip()
          this.copyCanvas()
          next()
        }
      })
    }

    sessionStorage.removeItem('isAuthorized')
  },
  methods: {
    /**
     * 设置页面顶部标题
     */
    initHeader() {
      let dataSetId = this.$route.query.datasetId
      getProjectTree({ dataSetId }).then(response => {
        if (response.isSuccess) {
          let dataSets = response.data

          let projName = this.$route.params.projName
          let dataSetName = dataSets[0].dataSetName
          this.setTitle(`${projName}-${dataSetName}`)
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    loadMainScene() {
      let dataType = this.$route.query.dataType
      if (dataType === 'Cad') {
        this.canvasViewMode = 'cad'
        this.viewTreePanelLimit = ''
        this.cadLayerPanelLimit = ''
        this.getCadData().then(cadData => {
          let cadInfo = cadData[0]
          let fileName = cadInfo.fileName
          cadInfo.name = fileName.substring(0, fileName.lastIndexOf('.'))
          this.rvtCadInfo = cadInfo
          this.$refs.engineDemo.loadDataSet(dataType, cadInfo)
        })
      }
      if (dataType !== 'Cad') {
        this.getDatasetResource().then(() => {
          this.getViewAngle().then(visualAngle => {
            if (visualAngle && visualAngle !== 'DefaultVisualAngle') {
              let camLoc = JSON.parse(visualAngle)
              this.$refs.engineDemo.setViewAngle(camLoc)
            }

            this.$refs.engineDemo.loadDataSet(dataType, this.modelInfo)
          })
        })
      }
    },
    getViewAngle() {
      return new Promise(resolve => {
        let datasetId = this.$route.query.datasetId
        let params = {
          definedType: 1,
          resourceId: datasetId
        }
        getViewAngleService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let visualAngle = data.visualAngle
            resolve(visualAngle)
          } else {
            this.$message.error(response.errMsg)
            resolve()
          }
        })
      })
    },
    onMainSceLoaded() {
      this.mainSceLoaded = true
      let dataType = this.$route.query.dataType
      if (dataType === 'Vector') {
        window.BlackHole3D.Graphics.setSysUIPanelVisible(false)
        window.BlackHole3D.Graphics.setGeoCoordVisible(false)
      }

      let isAuthorized = JSON.parse(sessionStorage.getItem('isAuthorized'))
      if (dataType === 'Bim') {
        this.viewTreePanelVisible = true

        // prettier-ignore
        if (this.isChecked("Project.Single.Metadata.Bim.Coplane") && isAuthorized ) {
          // 添加渲染优先级设置按钮
          let coplaneLightImg = this.getImgPath("coplaneLight.png");
          let coplaneLightCheckImg = this.getImgPath("coplaneLightCheck.png");
          let coplaneStateList = [];
          // prettier-ignore
          coplaneStateList.push({ hintText: "渲染优先级", texPath: coplaneLightImg });
          // prettier-ignore
          coplaneStateList.push({ hintText: "渲染优先级", texPath: coplaneLightCheckImg });
          this.$refs.engineDemo.addCustomBtn("Coplane", coplaneStateList, 0);
        }

        // 添加目录树按钮
        let treeLightImg = this.getImgPath('treeLight.png')
        let treeLightCheckImg = this.getImgPath('treeLightCheck.png')
        let treeStateList = []
        treeStateList.push({ hintText: '目录树', texPath: treeLightImg })
        treeStateList.push({ hintText: '目录树', texPath: treeLightCheckImg })
        this.$refs.engineDemo.addCustomBtn('Catalog_Tree', treeStateList, 1)

        // 添加属性按钮
        let attrLightImg = this.getImgPath('attrLight.png')
        let attrLightCheckImg = this.getImgPath('attrLightCheck.png')
        let attrStateList = []
        attrStateList.push({ hintText: '属性', texPath: attrLightImg })
        attrStateList.push({ hintText: '属性', texPath: attrLightCheckImg })
        this.$refs.engineDemo.addCustomBtn('Attribute', attrStateList, 0)

        let isDemoProj = JSON.parse(sessionStorage.getItem('isDemoProj'))
        if (!isDemoProj) {
          if (this.isChecked('Project.Single.Texture.List') && isAuthorized) {
            // 添加纹理动画按钮
            let texLightImg = this.getImgPath('texLight.png')
            let texLightCheckImg = this.getImgPath('texLightCheck.png')
            let texStateList = []
            texStateList.push({ hintText: '纹理动画', texPath: texLightImg })
            // prettier-ignore
            texStateList.push({ hintText: "纹理动画", texPath: texLightCheckImg });
            this.$refs.engineDemo.addCustomBtn('Texture', texStateList, 0)
          }
        }

        if (this.isChecked('Project.Single.Texture.List')) {
          this.renderTexture()
        }
      }
    },
    onCadLoadFinish() {
      this.cadLoadFinish = true

      if (this.canvasViewMode === 'bimCad') {
        this.updateAttributeType('')
        this.updateCadLayer()
        this.updateCadLayout()
        this.viewTreePanelLimit = 'left'
        this.cadLayerPanelLimit = 'right'
      } else {
        this.viewTreePanelLimit = ''
        this.cadLayerPanelLimit = ''
      }
    },
    isCadToolBarVisible() {
      let visible = false
      let canvasViewMode = this.canvasViewMode
      let cadLoadFinish = this.cadLoadFinish
      if (cadLoadFinish && canvasViewMode.toLowerCase().includes('cad')) {
        visible = true
      } else {
        visible = false
      }
      return visible
    },
    renderTexture() {
      let dataSetId = this.$route.query.datasetId
      getTextureList({ dataSetId }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let textureList = data.filter(el => el.isApplied && !el.removeStatus)
          if (textureList.length) {
            let BlackHole3D = window.BlackHole3D
            let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
            let resId = find.resId
            textureList.forEach(item => {
              let anim = new BlackHole3D.REElemUVAnim()
              anim.dataSetId = resId
              anim.elemIdList = item.elements
              let scale = Number((1 / item.compressionRatio).toFixed(2))
              anim.scale = [scale, 1]
              let speed = item.direction > 0 ? item.flowRate : -item.flowRate
              anim.speed = [speed, 0]

              BlackHole3D.BIM.setElemUVAnimAttr(anim)
            })
          }
        }
      })
    },
    getCadData() {
      return new Promise(resolve => {
        let datasetId = this.$route.query.datasetId
        getCadDatasetFiles({ datasetId }).then(response => {
          if (response.isSuccess) {
            let cadData = response.data.items
            resolve(cadData)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    toggleViewAngleBtn(visible) {
      this.viewAngleVisible = visible
    },
    isViewAngleVisible() {
      let dataType = this.$route.query.dataType
      if (dataType === 'Panorama' || dataType === 'Cad') {
        return false
      }

      return this.mainSceLoaded && this.viewAngleVisible
    },
    resetViewAngle() {
      let datasetId = this.$route.query.datasetId
      let params = {
        definedType: 1,
        resourceId: datasetId
      }
      getViewAngleService(params).then(response => {
        if (response.isSuccess) {
          const BlackHole3D = window.BlackHole3D

          let data = response.data
          let visualAngle = data.visualAngle
          if (visualAngle && visualAngle !== 'DefaultVisualAngle') {
            let visualAngleInfo = JSON.parse(visualAngle)

            let camLoc = new BlackHole3D.RECamLoc()
            camLoc.camPos = visualAngleInfo.camPos
            camLoc.camRotate = visualAngleInfo.camRotate
            BlackHole3D.Camera.setCamLocateTo(camLoc)
          } else {
            const cameraDir = BlackHole3D.RECamDirEm.CAM_DIR_TOPRIGHTBACK
            BlackHole3D.Camera.setCamLocateDefault(cameraDir, true)
          }
        }
      })
    },
    onUIThemeChange(theme) {
      let Graphics = window.BlackHole3D.Graphics

      if (theme.includes('Light')) {
        this.theme = 'light'

        let coplaneLightImg = this.getImgPath('coplaneLight.png')
        let coplaneLightCheckImg = this.getImgPath('coplaneLightCheck.png')
        Graphics.setBtnStatePicPath('Coplane', 0, coplaneLightImg)
        Graphics.setBtnStatePicPath('Coplane', 1, coplaneLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Coplane', 0)

        let treeLightImg = this.getImgPath('treeLight.png')
        let treeLightCheckImg = this.getImgPath('treeLightCheck.png')
        Graphics.setBtnStatePicPath('Catalog_Tree', 0, treeLightImg)
        Graphics.setBtnStatePicPath('Catalog_Tree', 1, treeLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Catalog_Tree', 0)

        let attrLightImg = this.getImgPath('attrLight.png')
        let attrLightCheckImg = this.getImgPath('attrLightCheck.png')
        Graphics.setBtnStatePicPath('Attribute', 0, attrLightImg)
        Graphics.setBtnStatePicPath('Attribute', 1, attrLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Attribute', 0)

        let texLightImg = this.getImgPath('texLight.png')
        let texLightCheckImg = this.getImgPath('texLightCheck.png')
        Graphics.setBtnStatePicPath('Texture', 0, texLightImg)
        Graphics.setBtnStatePicPath('Texture', 1, texLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Texture', 0)
      }

      if (theme.includes('Dark')) {
        this.theme = 'dark'

        let coplaneDarkImg = this.getImgPath('coplaneDark.png')
        let coplaneDarkCheckImg = this.getImgPath('coplaneDarkCheck.png')
        Graphics.setBtnStatePicPath('Coplane', 0, coplaneDarkImg)
        Graphics.setBtnStatePicPath('Coplane', 1, coplaneDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Coplane', 1)

        let treeDarkImg = this.getImgPath('treeDark.png')
        let treeDarkCheckImg = this.getImgPath('treeDarkCheck.png')
        Graphics.setBtnStatePicPath('Catalog_Tree', 0, treeDarkImg)
        Graphics.setBtnStatePicPath('Catalog_Tree', 1, treeDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Catalog_Tree', 1)

        let attrDarkImg = this.getImgPath('attrDark.png')
        let attrDarkCheckImg = this.getImgPath('attrDarkCheck.png')
        Graphics.setBtnStatePicPath('Attribute', 0, attrDarkImg)
        Graphics.setBtnStatePicPath('Attribute', 1, attrDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Attribute', 1)

        let texDarkImg = this.getImgPath('texDark.png')
        let texDarkCheckImg = this.getImgPath('texDarkCheck.png')
        Graphics.setBtnStatePicPath('Texture', 0, texDarkImg)
        Graphics.setBtnStatePicPath('Texture', 1, texDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Texture', 1)
      }
    },
    async handleModelClick(info) {
      let elemIds = window.BlackHole3D.BIM.getSelElemIDs()
      if (!elemIds.length || info.elemType !== 'BIMElem') {
        this.elementId = ''
        this.attributeData = []

        if (this.renderLevelVisible) {
          this.$refs.coplaneDialg.clearForm()
        }

        return
      }
      let elementInfo = JSON.parse(JSON.stringify(info))
      let elementId = elementInfo.elemId
      this.elementId = elementId

      if (this.canvasViewMode === 'bimCad') {
        this.queryCadElem(elementId)
      }

      // 如果以分组组织目录树，点击构件时，需要高亮构件所在分组的所有构件
      const isShowRvtGroup = this.$refs.viewTree?.isShowRvtGroup
      this.isRvtGroupMode = isShowRvtGroup ? true : false
      if (isShowRvtGroup) {
        const rvtGroupInfo = await this.getRvtGroupInfo()
        this.highLightGroupElems(rvtGroupInfo)

        if (this.attributePanelVisible) {
          const attributeData = await this.getRvtGroupAttr(rvtGroupInfo)
          this.attributeData = attributeData
        }
      } else {
        if (this.attributePanelVisible) {
          this.queryElementAttr()
        }
      }

      // 通过构件定位目录树
      // if (this.$refs.viewTree) {
      //   this.$refs.viewTree.locationTreeNodeByElemId(elementId);
      // }
    },
    async getRvtGroupInfo() {
      const dataSetId = this.$route.query.datasetId
      const getGroupIdparams = { dataSetId, elemIntId: this.elementId }
      const response = await getRvtGroupByElemIdService(getGroupIdparams)
      if (response.isSuccess) {
        return response.data
      } else {
        this.$message.error(response.errMsg)
      }
    },
    async queryElementAttr() {
      const dataSetId = this.$route.query.datasetId
      let params = {
        dataSetId: dataSetId,
        elementIntId: this.elementId,
        isQueryExtend: false
      }
      getProjectParam(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          this.attributeData = data.elementParamGroups
        } else {
          this.attributeData = []
        }
      })
    },
    async getRvtGroupAttr(rvtGroupInfo) {
      if (!rvtGroupInfo) {
        return []
      }

      const dataSetId = this.$route.query.datasetId
      const groupIntId = rvtGroupInfo.groupIntId
      const getGroupAttrParams = { dataSetId, groupIntId }
      const response = await getRvtGroupAttrService(getGroupAttrParams)
      if (response.isSuccess) {
        const data = response.data
        return data.params
      } else {
        this.$message.error(response.errMsg)
        return []
      }
    },
    async highLightGroupElems(rvtGroupInfo) {
      if (!rvtGroupInfo) return

      const dataSetId = this.$route.query.datasetId
      const hostFileId = rvtGroupInfo.hostFileId
      const groupIntId = rvtGroupInfo.groupIntId
      const params = {
        dataSetId,
        hostFileId: String(hostFileId),
        childNodeId: [groupIntId]
      }
      const response = await getBimElemIdsByGroupService(params)
      if (response.isSuccess) {
        const data = response.data
        const resId = dataSetId.replaceAll('-', '')
        const elemIds = data.childNodeIds.length
          ? data.childNodeIds
          : [this.elementId]
        highLightElems(resId, elemIds, false)
      } else {
        this.$message.error(response.errMsg)
      }
    },
    queryCadElem(elementId) {
      let dataSetId = this.$route.query.datasetId
      let hostFileId = this.rvtCadInfo.hostFileId
      let cadSheetId = this.rvtCadInfo.cadSheetId
      let params = {
        dataSetId,
        hostFileId,
        cadSheetId,
        elementIntId: elementId
      }
      getCadIdByElemId(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let cadElemInfo = data[0]
          let cadElemId = cadElemInfo.cadHandleId
          this.$refs.engineDemo.heightCADElement(cadElemId)
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    handleCadElemClick(cadElemId) {
      let dataType = this.$route.query.dataType
      if (dataType !== 'Bim') return

      let dataSetId = this.$route.query.datasetId
      let hostFileId = this.rvtCadInfo.hostFileId
      let cadSheetId = this.rvtCadInfo.cadSheetId
      let params = {
        dataSetId,
        hostFileId,
        cadSheetId,
        cadHandleId: cadElemId
      }
      getElemIdByCadId(params).then(response => {
        if (response.isSuccess) {
          let elemId = response.data
          this.highLightElement([elemId])
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    isVectorView() {
      let dataType = this.$route.query.dataType
      if (dataType === 'Vector') {
        return true
      } else {
        return false
      }
    },
    handleVectorClick(elemId) {
      let dataSetId = this.$route.query.datasetId
      let params = { dataSetId, elemId }
      getVectorAttrService(params).then(response => {
        if (response.isSuccess) {
          let vectorAttrData = response.data
          this.vectorAttrData = vectorAttrData
          this.isVectorAttrPanelVisible = true
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    openVectorAttrPanel() {
      this.isVectorAttrPanelVisible = true
    },
    closeVectorAttrPanel() {
      this.isVectorAttrPanelVisible = false
    },
    updateAttributeType(attributeType) {
      this.attributeType = attributeType
      this.closeAttributePanel()
    },
    updateAttributeData(data) {
      this.attributeData = data
    },
    async togglePanelVisible(btnName) {
      let Graphics = window.BlackHole3D.Graphics
      let btnStatus = Graphics.getBtnActiveState(btnName)
      if (btnName.includes('Coplane')) {
        this.renderLevelVisible = true

        this.texturePanelVisible = false
        this.attributePanelVisible = false
        this.viewTreePanelVisible = false
        window.BlackHole3D.Graphics.setBtnActiveState('Catalog_Tree', 0)
        window.BlackHole3D.Graphics.setBtnActiveState('Attribute', 0)
        window.BlackHole3D.Graphics.setBtnActiveState('Texture', 0)
      }
      if (btnName.includes('Catalog_Tree')) {
        if (this.renderLevelVisible) {
          this.$message.warning('请先退出编辑操作')
          window.BlackHole3D.Graphics.setBtnActiveState('Catalog_Tree', 0)
          return
        }

        if (btnStatus === 1) {
          this.viewTreePanelVisible = true
        } else {
          this.viewTreePanelVisible = false
        }
      }

      if (btnName.includes('Attribute')) {
        if (btnStatus === 1) {
          this.attributePanelVisible = true
          this.texturePanelVisible = false
          window.BlackHole3D.Graphics.setBtnActiveState('Texture', 0)

          if (this.elementId) {
            const isShowRvtGroup = this.$refs.viewTree?.isShowRvtGroup
            if (isShowRvtGroup) {
              const rvtGroupInfo = await this.getRvtGroupInfo()
              const attributeData = await this.getRvtGroupAttr(rvtGroupInfo)
              this.attributeData = attributeData
            } else {
              this.queryElementAttr()
            }
          }
        } else {
          this.attributePanelVisible = false
        }
      }

      if (btnName.includes('Texture')) {
        if (this.renderLevelVisible) {
          this.$message.warning('请先退出编辑操作')
          window.BlackHole3D.Graphics.setBtnActiveState('Texture', 0)
          return
        }

        if (btnStatus === 1) {
          this.texturePanelVisible = true
          this.attributePanelVisible = false
          window.BlackHole3D.Graphics.setBtnActiveState('Attribute', 0)
        } else {
          this.texturePanelVisible = false
        }
      }
    },
    closeRenderLevelDialog() {
      this.renderLevelVisible = false
      window.BlackHole3D.Graphics.setBtnActiveState('Coplane', 0)
    },
    openViewTreePanel() {
      this.viewTreePanelVisible = true
      window.BlackHole3D.Graphics.setBtnActiveState('Catalog_Tree', 1)
    },
    closeViewTreePanel() {
      this.viewTreePanelVisible = false
      window.BlackHole3D.Graphics.setBtnActiveState('Catalog_Tree', 0)
    },
    openCadLayerPanel() {
      this.cadLayoutPanelVisible = false
      this.cadlayerPanelVisible = true
    },
    updateCadLayer() {
      let dom = this.$refs.cadLayer
      if (dom) {
        dom.initCadLayerList()
      }
    },
    closeCadLayerPanel() {
      this.cadlayerPanelVisible = false
    },
    openCadLayoutPanel() {
      this.cadlayerPanelVisible = false
      this.cadLayoutPanelVisible = true
    },
    updateCadLayout() {
      let dom = this.$refs.cadLayout
      if (dom) {
        dom.initCadLayoutList()
      }
    },
    closeCadLayoutPanel() {
      this.cadLayoutPanelVisible = false
    },
    closeAttributePanel() {
      this.attributePanelVisible = false
      this.elementId = ''
      this.attributeData = []
      window.BlackHole3D.Graphics.setBtnActiveState('Attribute', 0)
    },
    closeTexturePanel() {
      this.texturePanelVisible = false
      window.BlackHole3D.Graphics.setBtnActiveState('Texture', 0)
    },
    reloadMainScene() {
      this.loadMainScene()
    },
    openEffectDialog(textureInfo) {
      this.effectDialog = true
      if (textureInfo.isPath) {
        this.textureInfo = textureInfo
      }
    },
    cloaseEffectDialog() {
      this.effectDialog = false
      this.textureInfo = null
      this.$refs.texture.cancelEffectSet()
    },
    openCountDown() {
      this.countDownVisible = true
    },
    submitEffectInfo(textureInfo) {
      return new Promise(resolve => {
        this.$refs.texture.setEffect(textureInfo).then(response => {
          resolve(response)
        })
      })
    },
    getDatasetResource() {
      let dataSetId = this.$route.query.datasetId
      return new Promise(resolve => {
        getDataSetResService({
          dataSetIds: [dataSetId]
        }).then(response => {
          if (response.isSuccess) {
            let dataSets = response.data
            this.modelInfo = dataSets
            resolve()
          }
        })
      })
    },
    setVisibleElemAlpha() {
      let dataSetId = this.$route.query.datasetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId

      let visibleElements = window.BlackHole3D.BIM.getDataSetAllElemIDs(
        resId,
        true
      )
      window.BlackHole3D.BIM.setElemAlpha(resId, visibleElements, 30)
    },
    showRoom(roomInfo) {
      let dataSetId = this.$route.query.datasetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId
      if (!roomInfo.levelHeightTop) {
        // 重置所有构件颜色，防止切换房间时，上次选中的房间颜色依旧存在
        window.BlackHole3D.BIM.resetElemAttr(resId, [])
        this.setVisibleElemAlpha()

        this.$refs.engineDemo.showRoomByElemId(resId, roomInfo.elemIntIds)
      } else {
        let deltaHeight = roomInfo.levelHeightTop - roomInfo.levelHeightBottom
        deltaHeight = Number((deltaHeight * 0.6).toFixed(2))
        let bottomHeight = Number(Number(roomInfo.levelHeightBottom).toFixed(2))

        this.$refs.engineDemo.showRoom(
          resId,
          bottomHeight + deltaHeight,
          bottomHeight,
          roomInfo.elemIntIds
        )
      }
    },
    loadBIMCAD(cadInfo) {
      this.rvtCadInfo = cadInfo
      this.$refs.engineDemo.loadBIMCAD(cadInfo, this.canvasViewMode)
    },
    resetElemAttr() {
      let dataSetId = this.$route.query.datasetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId
      window.BlackHole3D.BIM.resetElemAttr(resId, [])
    },
    highLightElement(childNodeIds, isRootnode) {
      let dataSetId = this.$route.query.datasetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find ? find.resId : ''

      this.$refs.engineDemo.highLightElement(resId, childNodeIds, isRootnode)
    },
    deleteCustomBtn(uiID) {
      window.BlackHole3D.Graphics.delWidget(uiID)
    },
    // 处理纹理编辑的非常规操作
    handleTextureEdit() {
      return new Promise(resolve => {
        let BlackHole3D = window.BlackHole3D
        let textureStatus = BlackHole3D.Pipe.getContPipeMode()
        if (textureStatus) {
          let message =
            '当前正处于纹理编辑状态，退出后纹理路径将丢失，确定退出？'
          this.$confirm(message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              BlackHole3D.Pipe.endEditContPipeMode()
              BlackHole3D.Graphics.setSysUIPanelVisible(true)
              resolve(true)
            })
            .catch(() => {
              this.$message.info('取消退出')
              resolve(false)
            })
        } else {
          resolve(true)
        }
      })
    },
    handleElemClick(elemId) {
      const dataSetId = this.$route.query.datasetId
      const BlackHole3D = window.BlackHole3D

      getTextureList({ dataSetId }).then(response => {
        if (response.isSuccess) {
          const textureList = response.data.filter(el => !el.removeStatus)

          // 找出当前正在编辑的路径，该路径包含的构件不在重复选择构件的检测范围
          const pipeId = BlackHole3D.Pipe.getCurContPipe()
          let findPath = textureList.find(el => el.id === pipeId)
          if (findPath && findPath.elements.includes(elemId)) return

          const elemIdList = textureList.flatMap(item => item.elements)
          if (elemIdList.includes(elemId)) {
            this.$message.warning('当前构件已被其他路径选择，请选择其他构件')
            let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
            BlackHole3D.Pipe.removeCurContPipeSubElem(find.resId, [elemId])
          }
        }
      })
    },
    setCanvasViewMode(canvasViewMode) {
      this.canvasViewMode = canvasViewMode
    },
    toggleCanvasViewMode() {
      if (this.canvasViewMode === 'bimCad') {
        this.viewTreePanelLimit = ''
        this.cadLayerPanelLimit = ''
        this.canvasViewMode = 'rvtCad'
        this.$refs.engineDemo.toggleCanvasViewMode('rvtCad')
      } else {
        this.viewTreePanelLimit = 'left'
        this.cadLayerPanelLimit = 'right'
        this.canvasViewMode = 'bimCad'
        this.$refs.engineDemo.toggleCanvasViewMode('bimCad')
      }
    },
    getImgPath(iconName) {
      let { origin, pathname } = window.location
      let iconPath = `${origin}${pathname.split('/index.html')[0]}`
      return `${iconPath}/engineIcon/${iconName}`
    },
    copyCanvas() {
      const canvasBox = document.getElementById('engineCanvas')
      if (canvasBox) {
        const canvasContainer = document.getElementById('canvas-container')
        canvasContainer.append(canvasBox)
      }
    },
    onMouseMove(eventInfo) {
      let { clientX, clientY } = eventInfo
      let BlackHole3D = window.BlackHole3D
      let visible = BlackHole3D.Pipe.getContPipeMode()
      this.mouseTipVisible = visible
      this.$refs.mouseTip.style.top = clientY - 60 + 'px'
      this.$refs.mouseTip.style.left = clientX + 'px'
    },
    onPathProgress(eventInfo) {
      let { visible, percentage } = eventInfo
      this.pathProgressVisible = visible
      this.pathProgress = percentage
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
.scene-box {
  position: relative;
  display: flex;
  width: 100%;
  height: calc(100vh - 64px);
  max-width: 100% !important;
  overflow: hidden;
  margin-top: -16px;

  .common-button-box {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 9;

    .icon {
      font-size: 18px;
    }
  }

  .engine-box {
    position: relative;
    flex-grow: 1;
    height: 100%;
    border-top: 1px solid var(--panel-border-color);

    .catalog-tree-btn-box {
      position: absolute;
      top: 6px;
      left: 10px;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bimview-left-toolbtn-bgColor);
      cursor: pointer;
      z-index: 2;
      border-radius: 10px;

      :deep(.svg-icon) {
        color: var(--bimview-toolbtn-text-color);
      }
    }

    .cad-toolbar-box {
      position: absolute;
      top: 5px;
      border-radius: 4px;
      padding: 0px 10px;
      z-index: 4;
      display: flex;
      align-items: center;

      .svg-box {
        background-color: var(--bimview-toolbtn-bgColor);
        border-radius: 10px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:not(:last-child) {
          margin-right: 16px;
        }
      }

      .icon {
        cursor: pointer;
        color: var(--bimview-toolbtn-text-color);
      }
    }

    .left0 {
      left: 0;
    }

    .margin30 {
      margin-left: 56px;
    }

    .left50 {
      left: 50%;
    }
  }

  .mouse-tip-box {
    position: absolute;
    top: 0px;
    left: 0px;
    min-width: 205px;
    margin-top: 10px;
    margin-left: 10px;
    padding: 10px;
    color: var(--eng-cursor-text-color);
    background: var(--base-bg-dark-color7);
    box-shadow: 0px 3px 6px var(--base-bg-dark-color8);
    text-align: left;
  }
}
</style>
